import React from "react";
import { useCartCount } from "../cart";
import { checkoutPanel } from "../checkout";
import { addedToast, useAddedToast } from "./ui";

/** "added: daily pack · view cart (2)", above the phone menu bar. */
export const AddedToastHost: React.FC = () => {
  const toast = useAddedToast();
  const count = useCartCount();
  return (
    <div className="sf-toast-host" aria-live="polite">
      {toast && (
        <div key={toast.id} className="sf-toast">
          <span className="sf-toast-text">
            added: <strong>{toast.name}</strong>
          </span>
          <button
            type="button"
            className="sf-toast-btn"
            onClick={() => {
              addedToast.hide();
              checkoutPanel.open();
            }}
          >
            view cart ({count})
          </button>
        </div>
      )}
    </div>
  );
};
